<template>
  <form ref="form">
    <h2>Add a new credit card</h2>
    <div v-if="message">{{ message }}</div>
    <div>
      <div>
        Card Type
        <select v-model="model.type">
          <option v-for="type in cardTypes" :key=type.value :value="type.value">{{type.text}}</option>
        </select>
      </div>
      <div>
        Card number
        <input type="number" v-model="model.number" />
      </div>
      <div>
        Expiration date
        <div class="grid">
          <select v-model="model.expMonth">
            <option v-for="month in months" :key=month.value :value="month.value">{{month.text}}</option>
          </select>
          <select v-model="model.expYear">
            <option v-for="year in years" :key=year.value :value="year">{{year}}</option>
          </select>
        </div>
      </div>
      <div>Security code
        <input type="number" v-model="model.security" />
      </div>
    </div>
    <div>
      <button @click="cancel" class="btn">Cancel</button>
      <button @click="create" class="btn primary">Add</button>
    </div>
  </form>
</template>

<script>
function getDefaultData() {
  return {
    model: {
      type: null,
      number: null,
      expMonth: null,
      expYear: null,
      security: null
    },
    mandatoryRules: [v => !!v || "This fiels is mandatory"],
    loading: false,
    valid: false,
    message: null,
    months: [
      { text: "01 - January", value: "01" },
      { text: "02 - Febuary", value: "02" },
      { text: "03 - March", value: "03" },
      { text: "04 - April", value: "04" },
      { text: "05 - May", value: "05" },
      { text: "06 - June", value: "06" },
      { text: "07 - Jully", value: "07" },
      { text: "08 - August", value: "08" },
      { text: "09 - September", value: "09" },
      { text: "10 - October", value: "10" },
      { text: "11 - November", value: "11" },
      { text: "12 - December", value: "12" }
    ],
    cardTypes: [
      { text: "Visa", value: "visa" },
      { text: "Mastercard", value: "mastercard" },
      { text: "Amex", value: "amex" }
    ]
  };
}
export default {
  props: {
    open: {
      type: Boolean
    },
    customerId: {
      type: Number
    }
  },
  data: getDefaultData,
  computed: {
    displayForm: function() {
      return this.open;
    },
    years: function() {
      let year = [];
      let now = new Date().getFullYear();
      for (let index = 0; index < 20; index++) {
        year.push("" + (now + index));
      }
      return year;
    }
  },
  methods: {
    validate(){
      if(this.model.type && this.model.number && this.model.expMonth && this.model.expYear && this.model.security){
        return true;
      }
      return false;
    },
    create(e) {
      e.preventDefault();
      if (this.validate()) {
        this.loading = true;
        this.$store
          .dispatch("card/create", {
            model: this.model
          })
          .then(result => {
            if (result.id) {
              this.$emit("add", result.id);
              this.resetForm();
            } else {
              for (let index = 0; index < result.length; index++) {
                const error = result[index];
                if (error.type == "invalidFields") {
                  this.message =
                    "The credit card information are false, please check and retry";
                }
              }
            }
          })
          .finally(() => (this.loading = false));
      }
    },
    cancel(e) {
      e.preventDefault();
      this.$emit("cancel");
      this.resetForm();
    },
    resetForm() {
      Object.assign(this.$data, getDefaultData());
      this.$refs.form.reset();
    }
  }
};
</script>

<style scoped>
h2{
  font-size: 20px;
  color:#2F2B2B;
  font-weight: bold;
  margin-bottom: 1em;;
}
</style>
